/**
 * Finds and formats a BEAT ID from repository topics.
 * Searches for topics starting with "beat" (case-insensitive) followed by digits.
 * Normalizes the topic by removing special characters and returns uppercase with 8-digit padding.
 *
 * @example
 * findBeatIdInTopics(['BEAT00005044']) // returns 'BEAT00005044'
 * findBeatIdInTopics(['beat_5044'])    // returns 'BEAT00005044'
 * findBeatIdInTopics(['BEAT-123'])     // returns 'BEAT00000123'
 * findBeatIdInTopics(['beat-not-applicable']) // returns null
 */
export function findBeatIdInTopics(topics: string[] = []): string | null {
  const found = topics.find(topic => {
    if (!topic?.toLowerCase().startsWith('beat')) {
      return false;
    }
    const normalized = topic.toLowerCase().replace(/[^a-z0-9]/g, '');
    return /^beat\d+$/.test(normalized);
  });

  if (!found) {
    return null;
  }

  const normalized = found.toLowerCase().replace(/[^a-z0-9]/g, '');
  const digits = normalized.replace('beat', '');
  const paddedDigits = digits.padStart(8, '0');

  return `BEAT${paddedDigits}`;
}
